<script setup lang="ts">
interface Props {
  completed: number
  total: number
  label: string
  size?: 'small' | 'large'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large',
})

const steps = computed(() => Array.from({ length: Math.max(0, props.total) }, (_, index) => index < props.completed))
</script>

<template>
  <div class="milestone-stepper" :class="`-${size}`" role="img" :aria-label="label">
    <span
      v-for="(isDone, index) in steps"
      :key="index"
      class="milestone-stepper-step"
      :class="{ '-done': isDone }"
    />
  </div>
</template>

<style scoped lang="scss">
.milestone-stepper {
  @apply flex w-full;

  &.-large {
    gap: 6px;

    .milestone-stepper-step {
      @apply h-4 rounded-[6px];
    }
  }

  &.-small {
    @apply gap-2;

    .milestone-stepper-step {
      @apply h-[10px] rounded-md;
    }
  }

  .milestone-stepper-step {
    @apply flex-1 bg-neutral-high-light;

    &.-done {
      @apply bg-brand-secondary-pure;
    }
  }
}
</style>
